import React, { Component } from 'react';
// import { Col, Container, Row } from "reactstrap";
import { Row, Col} from "antd";
import sdgood from "../../assets/banner/sandee_good.png";
import sdword from "../../assets/banner/sandeeword.png";

export default class Banner extends Component {
    constructor(props) {
        console.log('components/Banner')
        super(props);
    }

    render() {
        return (
            <div>
                {/* <div className="sandeebanner_mobile sandeebanner"></div> */}

                <Row className="sandeeRowInfo"
                    justify="center" 
                    gutter={[{ xs: 8, sm: 8, md: 10, lg: 12, xl: 24, xxl:24 },8]}
                >
                    <Col className="col-sandeepic"
                        span={6}
                    >
                        <img alt="" className="sandeegood_icon" src={sdgood} />
                    </Col>
                    <Col className="col-sandeeword" 
                        span={12}
                    >
                        <img alt="" className="sandeeword" src={sdword} />
                    </Col>
                </Row>
            </div>
        )
    }
}